import _util from '../../utils/';
const weeklyQuestionSummaryService = {
	exportSummary(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/Export',
			params: gets,
			success: resolve,
			error: reject
		})			
    },

	getQuestionList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/Get',
			params: gets,
			success: resolve,
			error: reject
		})			
    },
    getQuestionSummaryDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/Details?id='+gets.id,
			params: gets,
			success: resolve,
			error: reject
		})			
	},
    downloadQuestionSummaryDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/DownloadDetails?id='+gets.id,
			params: gets,
			success: resolve,
			error: reject
		})			
	},
	updateQuestionSummary(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	updateAndSendQuestionSummary(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportWeeklySummary/PutAndSend',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
}

export default weeklyQuestionSummaryService;


// WEBPACK FOOTER //
// ./src/services/WorkReport/weekly-question-summary-service.js